import { Utils } from "../utilities/Utils";
import { mapData } from "@/utilities/DataMapping";

export interface IMapCoords {
    west: string;
    south: string;
    east: string;
    north: string;
}

export class MapCoords implements IMapCoords {

    constructor(data?: IMapCoords) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IMapCoords) {
        mapData(data, { root: () => this });
    }

    west: string = "";
    south: string = "";
    east: string = "";
    north: string = "";

}